<ng-container *ngIf="useWorkspaces && canDelete">
  <button type="button" class="btn btn-danger" (click)="deleteWorkspace()" [disabled]="!canDelete">Delete
    Workspace
  </button>
</ng-container>
